import { useMemo } from 'react';
import styles from './FJPreviewBox.module.less';
import FJUtil from '../../../util/FJUtil';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FJPreviewBox = props => {
    const { imageInfo, style, className } = props;
    const { width, height, src } = imageInfo;
    const previewSize = useMemo(() => {
        if (!width || !height || !src) return;
        return FJUtil.getPreviewSize({ width, height });
    }, [width, height, src]);
    return (
        <div className={classNames(styles.hover_box, className)}>
            {previewSize && (
                <div
                    onClick={e => e.stopPropagation()}
                    className={styles.preview_box}
                    style={{ width: previewSize.width, height: previewSize.height, ...style }}
                >
                    <img className={styles.preview_img} src={src} alt='' loading='lazy' />
                    {/* <div className={styles.transparent_box}></div> */}
                </div>
            )}
        </div>
    );
};

FJPreviewBox.propTypes = {
    style: PropTypes.object,
    imageInfo: PropTypes.object,
};

export default FJPreviewBox;
